import {ApiClient} from '@hconnect/apiclient'
import {useMutation} from '@tanstack/react-query'
import {AxiosError} from 'axios'

import {EditMaterialDTO} from '../types'

type Variables = {plantCode: string; materialId: number; dto: EditMaterialDTO}

export const useEditMaterial = ({
  onError,
  onSuccess,
  onSettled
}: {
  onError?: (error: AxiosError, variables: Variables) => void
  onSuccess?: (data: void, variables: Variables) => void
  onSettled?: (data: void | undefined, error: AxiosError | null, variables: Variables) => void
} = {}) =>
  useMutation<void, AxiosError, Variables>({
    mutationFn: async ({plantCode, materialId, dto}) => {
      await ApiClient.axiosInstance.patch<void>(`/plants/${plantCode}/materials/${materialId}`, dto)
    },
    onError,
    onSuccess,
    onSettled
  })
